function getDefaultScene() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.APP?.scene;
}

export function isStorageLimitError(error) {
  return error?.status === 402 || error?.response?.status === 402;
}

function storageLimitData(error) {
  return error?.data || error?.response?.data?.data || error?.response?.data || {};
}

function normalizeId(value) {
  return value === undefined || value === null ? null : String(value);
}

function storageLimitDetail(error, { authUser, workspace } = {}) {
  const data = storageLimitData(error);
  const storageOwnerUserId =
    normalizeId(data.storageOwnerUserId) ||
    normalizeId(data.storage_owner_user_id) ||
    normalizeId(workspace?.owner_identity_user_id) ||
    normalizeId(workspace?.ownerIdentityUserId) ||
    normalizeId(workspace?.user_id) ||
    normalizeId(workspace?.userId) ||
    null;
  const authUserId = normalizeId(authUser?.id || authUser?.profile?.id);
  const workspaceId =
    normalizeId(data.workspaceId) ||
    normalizeId(data.workspace_id) ||
    normalizeId(workspace?.id) ||
    normalizeId(workspace?.ulid);

  return {
    ...data,
    workspaceId,
    storageOwnerUserId,
    ...(authUserId && storageOwnerUserId ? { isOwnedWorkspace: authUserId === storageOwnerUserId } : {})
  };
}

export function emitStorageLimitReached(scene = getDefaultScene(), detail) {
  if (!scene?.emit) {
    return false;
  }

  scene.emit("storage_limit_reached", detail);
  return true;
}

export function handleStorageLimitError(error, scene = getDefaultScene(), options = {}) {
  if (!isStorageLimitError(error)) {
    return false;
  }

  return emitStorageLimitReached(scene, storageLimitDetail(error, options));
}
